import { MutationHookOptions, useMutation } from '@apollo/client'
import {
  DeleteTagDocument,
  DeleteTagMutation,
  DeleteTagMutationVariables,
} from 'generated/resources/graphql'

import type { Tag } from 'modules/ats/hooks/tags/useTags'

type Options = MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>

export const useDeleteTag = (tag: Tag, options: Options) => {
  const [deleteTagMutation, { loading }] = useMutation(DeleteTagDocument, options)

  return {
    loading,
    deleteTag() {
      return deleteTagMutation({
        variables: { id: tag.id },
        update(cache) {
          cache.evict({ id: cache.identify(tag) })
        },
      })
    },
  }
}
